import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoggingService } from 'app/wipperoz-core/services/logging.service';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FeedbackService } from './feedback.service';
import { Feedback } from './types/feedback.model';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit, OnDestroy {
  feedback: Feedback[] = [];
  showAnimation = false;
  feedbackSlides: OwlOptions = {
    loop: true,
    nav: false,
    smartSpeed: 10000,
    autoplayTimeout: 10000,
    dots: true,
    animateOut: 'fadeOut',
    autoplayHoverPause: true,
    autoplay: true,
    items: 1
  };

  private unsubscribeAll: Subject<any>;
  constructor(private feedbackService: FeedbackService, private loggingService: LoggingService) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.feedbackService.onFeedbackChanged.pipe(takeUntil(this.unsubscribeAll)).subscribe(
      (data) => {
        if (data.length > 0) {
          this.feedback = data;
        }
      },
      (err) => {
        this.loggingService.logError('Error getting feedback content', JSON.stringify(err));
      }
    );
    this.feedbackService.getFeedback();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
